import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const OsnashenieDetail = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    updated(){

    },
    mounted(){

        if($(this.$el).find('.js-instrument-slider').length){
            let mpSwiperServ = new Swiper('.js-instrument-slider', {
                loop: true,
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                delay: 3000
                },
                pagination: {
                el: ".js-instrument-pag",
                type: "bullets",
                clickable: true
                },
                navigation: {
                nextEl: ".js-instrument-btn-next",
                prevEl: ".js-instrument-btn-prev"
                }
            });
        }

        if($(this.$el).find('[data-fancybox]').length){
            $(this.$el).find('[data-fancybox]').fancybox({
                loop: true,
            });
        }
    },
    methods: {
        showModalForm(){
            $('#order').modal();
        },
        zoomIn(){
            $(this.$el).find('.swiper-slide-active').find('a').trigger('click');
        },
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'SITE_TEMPLATE_PATH', 'struct', 'title'])
    },
    template: `
<div style="display: contents;">
<section class="section section--first">
    <div class="container">
        <div class="projects__intra">
            <div class="projects__intra-text content">
                <div style="display: contents;" v-html="this.struct[this.structKey].componentData.DESCRIPTION">
                </div>
                <a href="#" class="btn btn--green" @click.prevent="showModalForm()">Отправить заявку</a>
            </div>
            <div v-if="this.struct[this.structKey].componentData.GALLERY && this.struct[this.structKey].componentData.GALLERY.length" class="projects__intra-rightside js-instrument-slider-wp">
                <div class="projects__intra-rightside-inner">
                    <div class="swiper projects__intra-slider js-instrument-slider">
                        <div class="swiper-wrapper">

                            <div v-for="galItem in this.struct[this.structKey].componentData.GALLERY" class="swiper-slide">
                                <a :href="galItem.BIG" class="projects__intra-slider-img" data-fancybox="project-detail">
                                    <img :src="galItem.MEDIUM" :alt="this.struct[this.structKey].componentData.NAME" :title="this.struct[this.structKey].componentData.NAME" loading="lazy">
                                </a>
                            </div>

                        </div>
                    </div>
                    <a href="#" class="zoom js-instrument-zoom" @click.prevent="zoomIn()">
                        <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                    </a>
                    <div class="slider-arrows">
                        <div class="swiper-button-prev slider-btn js-instrument-btn-prev">
                            <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        </div>
                        <div class="swiper-button-next slider-btn js-instrument-btn-next">
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination js-instrument-pag"></div>
            </div>
            <div v-else class="projects__intra-rightside">
                <div class="projects__intra-rightside-inner">
                    <div class="swiper projects__intra-slider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <span class="projects__intra-slider-img no-photo">
                                    <img :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" alt="" title="" loading="lazy">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section v-if="this.struct[this.structKey].componentData.VIDEO !== false" class="section section--gray2">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Видеообзор по оснащению {{this.struct[this.structKey].componentData.VIDEO_HEADER}}
                </h2>
            </div>
        </div>
        <div class="videoobzor">
            <a :href="this.struct[this.structKey].componentData.VIDEO.SRC" class="videoobzor__item" data-fancybox="videoobzor">
                <video :poster="this.struct[this.structKey].componentData.VIDEO.POSTER" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                    <source :src="this.struct[this.structKey].componentData.VIDEO.SRC" :type="this.struct[this.structKey].componentData.VIDEO.CONTENT_TYPE">
                </video>
                <div class="block-play">
                    <svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg>
                </div>
                <div class="videoobzor__item-info">
                    <div class="videoobzor__item-name">
                        {{this.struct[this.structKey].componentData.VIDEO.NAME}}
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                    <div v-if="this.struct[this.structKey].componentData.VIDEO.YEAR !== false" class="videoobzor__item-year">{{this.struct[this.structKey].componentData.VIDEO.YEAR}}</div>
                </div>
            </a>
        </div>
    </div>
</section>
</div>
`
}